import { useState } from "react";
import { Link } from "react-router-dom";
import { QUIZ } from "@/constants/testIds";

const QUESTIONS = [
  { q: "Who is this for?", options: [
    { label: "Home use / personal", weight: "go" },
    { label: "Professional venue (bar, restaurant, hotel, events)", weight: "pro" },
  ] },
  { q: "What kinds of drinks?", options: [
    { label: "Sodas, sparkling cocktails, mocktails", weight: "go" },
    { label: "Foams, infusions, macerations, complex batches", weight: "pro" },
  ] },
  { q: "How much support do you need?", options: [
    { label: "I'm comfortable running the system myself", weight: "go" },
    { label: "I need training, maintenance and ongoing support", weight: "pro" },
  ] },
];

export default function Quiz() {
  const [step, setStep] = useState(0);
  const [score, setScore] = useState({ go: 0, pro: 0 });
  const answer = (w) => {
    const next = { ...score, [w]: score[w] + 1 };
    setScore(next);
    setStep(step + 1);
  };
  if (step >= QUESTIONS.length) {
    const winner = score.pro > score.go ? "pro" : "go";
    return (
      <div data-testid={QUIZ.result} className="text-white max-w-2xl mx-auto px-6 py-20 text-center">
        <span className={winner === "go" ? "preshh-badge-go" : "preshh-badge-pro"}>Your match</span>
        <h1 className={`font-display text-5xl md:text-6xl mt-5 ${winner === "go" ? "text-white" : "text-white"}`}>
          {winner === "go" ? "Preshh GO" : "Preshh PRO"}
        </h1>
        <p className="mt-4 text-white/70">
          {winner === "go"
            ? "Portable, personal, and ready when you are."
            : "The full service platform for professional venues."}
        </p>
        <Link
          to={winner === "go" ? "/preshhgo" : "/professional"}
          className={winner === "go" ? "mt-8 inline-flex preshh-btn-primary" : "mt-8 inline-flex preshh-btn-pro"}
        >
          {winner === "go" ? "Buy Preshh GO" : "Talk to a Consultant"}
        </Link>
      </div>
    );
  }
  const cur = QUESTIONS[step];
  return (
    <div className="text-white max-w-2xl mx-auto px-6 py-20">
      <p className="uppercase text-xs tracking-[0.3em] text-[#00B5D8] mb-3">Question {step + 1} / {QUESTIONS.length}</p>
      <h1 className="font-display text-3xl md:text-4xl mb-8">{cur.q}</h1>
      <div className="space-y-3">
        {cur.options.map((o, i) => (
          <button key={i} data-testid={QUIZ.answer(i)} onClick={() => answer(o.weight)}
            className="w-full text-left bg-[#111] hover:bg-[#161616] border border-white/10 hover:border-[#00B5D8]/50 rounded-2xl p-5 transition-colors">
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}
